var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.51953V4.39453M14.375 2.51953V4.39453M2.5 15.6445V6.26953C2.5 5.234 3.33947 4.39453 4.375 4.39453H15.625C16.6605 4.39453 17.5 5.234 17.5 6.26953V15.6445M2.5 15.6445C2.5 16.6801 3.33947 17.5195 4.375 17.5195H15.625C16.6605 17.5195 17.5 16.6801 17.5 15.6445M2.5 15.6445V9.39453C2.5 8.359 3.33947 7.51953 4.375 7.51953H15.625C16.6605 7.51953 17.5 8.359 17.5 9.39453V15.6445",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cc023ae02a85f69f4c6d2cfafc2f41a0.svg";
export { ForwardRef as ReactComponent };